import _extends from "@babel/runtime/helpers/esm/extends";
import { SuperDashboardCard } from "../../SuperDashboard";
import { Typography } from 'antd';
import React from 'react';
import { useStyles } from "./_.style";
export var SimpleResourceStatistics = /*#__PURE__*/React.forwardRef(function (properties, ref) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  return /*#__PURE__*/React.createElement(SuperDashboardCard, _extends({
    ref: ref
  }, properties), /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100px',
      // fontSize: '24px',
      // fontWeight: '500',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center'
    }
  }, properties.datum.map(function (data) {
    return /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: styles.item,
      style: {
        width: "calc(100% / ".concat(properties.datum.length, " - 10px)")
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: '50px',
        width: '100%',
        flex: '0 1'
      }
    }, /*#__PURE__*/React.createElement(Typography.Text, {
      ellipsis: true,
      style: {
        color: '#0076F7',
        fontSize: '24px',
        fontWeight: '500'
      }
    }, data.value)), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '14px',
        color: '#707275',
        marginTop: '4px'
      }
    }, data.key)));
  })), properties.children);
});
SimpleResourceStatistics.isProCard = true;